import React, { ChangeEvent, useEffect, useState } from "react";

import { components, GroupBase, InputProps } from "react-select";

type Option = { label: string; value: string };

type Extra = {
  keyword: string | null;
  setEditingKeyword: React.Dispatch<React.SetStateAction<string | null>>;
  onCreateOption: (value: string) => void;
  canCreateOption: (value: string, name: string) => boolean;
  onRemoveKeyword: (keyword: string) => void;
  isDisabled?: boolean;
};

type InputComponentProps = InputProps<Option, true, GroupBase<Option>> & Extra;

const Input: React.FC<InputComponentProps> = ({
  keyword,
  setEditingKeyword,
  onCreateOption,
  canCreateOption,
  onRemoveKeyword,
  ...props
}) => {
  const [value, setValue] = useState("");
  const { onChange } = props;

  useEffect(() => {
    if (keyword) {
      setValue(keyword);
      onChange?.({
        currentTarget: { value: keyword },
      } as unknown as ChangeEvent<HTMLInputElement>);
    }
  }, [keyword, onChange]);

  return (
    <components.Input
      {...props}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        props.onChange?.(e);
        setValue(e.target.value);
      }}
      data-testid="creatable-select-input"
      value={value}
      disabled={props.isDisabled}
      onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
        const nameForCheck = props.name ?? "";
        const canCreate = canCreateOption(value, nameForCheck);

        if (keyword && canCreate) {
          onRemoveKeyword(keyword);
        }
        setEditingKeyword(null);
        setValue("");
        onCreateOption(value);
        props.onBlur?.(e);
      }}
    />
  );
};

export default Input;
